import React from 'react';
import { Link } from 'react-router-dom';
import { toCurrency } from '@/shared/helpers';
import { formatAccountAge, formatDateTime, userName, classificationBadgeClass } from './helpers';

// Columns not listed here must set disableSortBy: true - the backend
// (RedemptionReviewService::ALLOWED_SORTS) only accepts redemption_datetime,
// final_score, classification, redemption_value, and account_age_hours;
// anything else it silently falls back to sorting by redemption_datetime,
// which would otherwise look like a broken/reverted sort.
export const REDEMPTION_RISK_EVENT_COLUMNS = [
    {
        Header: 'Date/Time',
        accessor: 'redemption_datetime',
        Cell: ({ value }) => formatDateTime(value),
        width: 150,
    },
    {
        Header: 'User',
        accessor: 'user.email',
        Cell: ({ row }) => (
            <Link to={`/approvals/redemptions/${row.original.id}`}>{userName(row.original.user)}</Link>
        ),
        disableSortBy: true,
    },
    {
        Header: 'Program',
        accessor: 'program.name',
        Cell: ({ value }) => value || '—',
        disableSortBy: true,
    },
    {
        Header: 'Amount',
        accessor: 'redemption_value',
        Cell: ({ value }) => toCurrency(value),
        width: 100,
    },
    {
        Header: 'Merchant',
        accessor: 'merchant.name',
        Cell: ({ value }) => value || '—',
        disableSortBy: true,
    },
    {
        Header: 'Score',
        accessor: 'final_score',
        width: 70,
    },
    {
        Header: 'Classification',
        accessor: 'classification',
        Cell: ({ value }) => <span className={classificationBadgeClass(value)}>{value}</span>,
        width: 130,
    },
    {
        Header: 'Account Age',
        accessor: 'account_age_hours',
        Cell: ({ value }) => formatAccountAge(value),
        width: 100,
    },
    {
        Header: 'Recent Count',
        accessor: 'recent_redemption_count',
        Cell: ({ value }) => (value === null || typeof value === 'undefined' ? '—' : value),
        width: 100,
        disableSortBy: true,
    },
    {
        Header: 'Recent Value',
        accessor: 'recent_redemption_value',
        Cell: ({ value }) => (value === null || typeof value === 'undefined' ? '—' : toCurrency(value)),
        width: 110,
        disableSortBy: true,
    },
    {
        Header: 'Status',
        accessor: 'status',
        width: 120,
        disableSortBy: true,
    },
    {
        Header: 'Review Status',
        accessor: 'review_decision',
        Cell: ({ row }) => {
            const { review_decision: decision, reviewer, reviewed_at: reviewedAt, marked_safe: markedSafe } = row.original;
            if (!decision && !markedSafe) return '—';
            return (
                <span>
                    {decision && (
                        <>
                            {decision}
                            {reviewer ? <><br /><small>{reviewer.name}</small></> : null}
                            {reviewedAt ? <><br /><small>{formatDateTime(reviewedAt)}</small></> : null}
                        </>
                    )}
                    {decision && markedSafe ? <br /> : null}
                    {markedSafe && (
                        <>
                            MARKED SAFE
                            {markedSafe.reviewer ? <><br /><small>{markedSafe.reviewer}</small></> : null}
                            {markedSafe.cleared_at ? <><br /><small>{formatDateTime(markedSafe.cleared_at)}</small></> : null}
                        </>
                    )}
                </span>
            );
        },
        width: 150,
        disableSortBy: true,
    },
    {
        Header: 'Action',
        accessor: '',
        Cell: ({ row }) => <Link to={`/approvals/redemptions/${row.original.id}`}>View</Link>,
        width: 70,
        disableSortBy: true,
    },
];
